// users views
const UserMyProfile = () => import("Core/users/views/UserMyProfile");
const Notifications = () => import("Core/users/views/Notifications");
const UserMyOrgs = () => import("Core/users/views/UserMyOrgs");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "users/my_profile",
            name: "users_my_profile",
            component: UserMyProfile,
            meta: {
                requiresAuth: true,
                title: "lang.userProfile",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: [],
            },
        },
        {
            path: "users/my_organizations",
            name: "users_my_organizations",
            component: UserMyOrgs,
            meta: {
                requiresAuth: true,
                title: "lang.userOrganizations",
                restrict_by_login_type: [],
            },
        },
    ],
};
